import { ensureValidAccessToken } from '@/utils/auth'
import { useAuthStore } from '@/stores/auth-store'
import HomeView from '../views/HomeView.vue'
import Dashboard from '@/views/Dashboard.vue'
import Suppliers from '@/views/Suppliers/Suppliers.vue'
import Customers from '@/views/Customers/Customers.vue'
import Yarns from '@/views/Yarns/Yarns.vue'
import AddSupplierView from '@/views/Suppliers/AddSupplierView.vue'
import AddCustomerView from '@/views/Customers/AddCustomerView.vue'
import EditCustomerView from '@/views/Customers/EditCustomerView.vue'
import CustomerListView from '@/views/Customers/CustomerListView.vue'
import SupplierListView from '@/views/Suppliers/SupplierListView.vue'
import EditSupplierView from '@/views/Suppliers/EditSupplierView.vue'
import CustomerDetailsView from '@/views/Customers/CustomerDetailsView.vue'
import YarnListView from '@/views/Yarns/YarnListView.vue'
import SupplierDetailsView from '@/views/Suppliers/SupplierDetailsView.vue'
import ArchievedListView from '@/views/Yarns/ArchievedListView.vue'
import AddMergeView from '@/views/Yarns/AddMergeView.vue'
import YarnDetailsView from '@/views/Yarns/YarnDetailsView.vue'
import EditYarnView from '@/views/Yarns/EditYarnView.vue'
import ProductSpecification from '@/views/ProductSpecification/ProductSpecification.vue'
import ProductSpecificationListView from '@/views/ProductSpecification/ProductSpecificationListView.vue'
import ProductSpecificationDetailsView from '@/views/ProductSpecification/ProductSpecificationDetailsView.vue'
import EditProductSpecificationView from '@/views/ProductSpecification/EditProductSpecificationView.vue'
import AddProductView from '@/views/ProductSpecification/AddProductView.vue'
import ArchivedProductSpecificationListView from '@/views/ProductSpecification/ArchivedProductSpecificationListView.vue'
import { createRouter, createWebHistory } from 'vue-router'
import BatchesListView from '@/views/Batches/BatchesListView.vue'
import AddBatchView from '@/views/Batches/AddBatchView.vue'
import BatchDetailsView from '@/views/Batches/BatchDetailsView.vue'
import ReturnedBatchDetailsview from '@/views/Batches/ReturnedBatchDetailsview.vue'
import RollsListView from '@/views/rolls/RollsListView.vue'
import Rolls from '@/views/rolls/Rolls.vue'
import RollsDetailsView from '@/views/rolls/RollsDetailsView.vue'
import EditRollView from '@/views/rolls/EditRollView.vue'
import Orders from '@/views/Orders/Orders.vue'
import OrderListView from '@/views/Orders/OrderListView.vue'
import AddOrderView from '@/views/Orders/AddOrderView.vue'
import CreatePackingListView from '@/views/Orders/CreatePackingListView.vue'
import OrderDetailsView from '@/views/Orders/OrderDetailsView.vue'
import EditOrderView from '@/views/Orders/EditOrderview.vue'
import CancelledOrdersView from '@/views/Orders/CancelledOrdersView.vue'
import PackingList from '@/views/PackingList/PackingList.vue'
import PackingListView from '@/views/PackingList/PackingListView.vue'
import PackingListDetailsView from '@/views/PackingList/PackingListDetailsView.vue'
import EditPackingListView from '@/views/PackingList/EditPackingListView.vue'
import SendToSupplier from '@/views/rolls/SendToSupplier.vue'
import ReturnedFromSupplier from '@/views/Batches/ReturnFromSupplier.vue'
import AvailableBatchesDetails from '@/views/Batches/AvailableBatchesDetails.vue'
import DispatchedBatchesDetails from '@/views/Batches/DispatchedBatchesDetails.vue'
import LoginView from '@/views/auth/LoginView.vue'
import ActivateAccountView from '@/views/auth/ActivateAccountView.vue';
import UserListView from '@/views/user/UserListView.vue'
import UserProfileView from '@/views/user/UserProfileView.vue'
import BankDetailView from '@/views/user/BankDetailView.vue'
import Users from '@/views/user/Users.vue'
import ProductionByMachineView from "@/views/Reports/ProductionByMachineView.vue";
import ProductionBySupplierView from "@/views/Reports/ProductionBySupplierView.vue";
import ProductionByQualityView from "@/views/Reports/ProductionByQualityView.vue";
import SalesByCustomerView from "@/views/Reports/SalesByCustomerView.vue";
import SalesByQualityView from "@/views/Reports/SalesByQualityView.vue";
import ForgotPasswordView from "@/views/auth/ForgotPasswordView.vue";
import ResetPasswordView from "@/views/auth/ResetPasswordView.vue";
import CostToSaleAnalysisView from "@/views/Reports/CostToSaleAnalysisView.vue";
import YarnStockValueView from "@/views/Reports/YarnStockValueView.vue";
import BatchStockView from "@/views/Reports/BatchStockView.vue";

const APP_NAME = 'Techknital Fabrics Ltd'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: () => {
        return '/dashboard'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: {
        title: `Login | ${APP_NAME}`
      }
    },
    {
      path: '/activate-account',
      name: 'activateAccount',
      component: ActivateAccountView,
      meta: {
        title: `Activate Account | ${APP_NAME}`,
        public: true
      }
    },
    {
      path: '/forgot-password',
      name: 'forgotPassword',
      component: ForgotPasswordView,
      meta: {
        title: `Forgot Password | ${APP_NAME}`,
        public: true
      }
    },
    {
      path: '/reset-password',
      name: 'resetPassword',
      component: ResetPasswordView,
      meta: {
        title: `Reset Password | ${APP_NAME}`,
        public: true
      }
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      children: [
        {
          path: '',
          name: 'userListView',
          component: UserListView,
          meta: {
            title: `Users | ${APP_NAME}`,
            breadcrumb: [{ label: 'Home' }, { label: 'Users' }]
          }
        },
        {
          path: '/profile',
          name: 'UserProfile',
          component: UserProfileView,
          meta: {
            title: `User Profile | ${APP_NAME}`,
            requiresAuth: true,
            breadcrumb: [{ label: 'Home' }, { label: 'User Profile' }]
          }
        },
        {
          path: '/bankDetail',
          name: 'BankDetail',
          component: BankDetailView,
          meta: {
            title: `Bank Detail | ${APP_NAME}`,
            requiresAuth: true,
            breadcrumb: [{ label: 'Home' }, { label: 'Bank Detail' }]
          }
        },
      ]
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        title: `Dashboard | ${APP_NAME}`,
        breadcrumb: [{ label: 'Home' }, { label: 'Dashboard' }]
      }
    },
    {
      path: '/customers',
      name: 'customers',
      component: Customers,
      children: [
        {
          path: '',
          name: 'customerList',
          component: CustomerListView,
          meta: {
            title: `Customers | ${APP_NAME}`,
            breadcrumb: [{ label: 'Home' }, { label: 'Customers' }]
          }
        },
        {
          path: ':id',
          name: 'customerDetails',
          component: CustomerDetailsView,
          meta: {
            title: `Customer Details | ${APP_NAME}`,
            breadcrumb: [{ label: 'Home' }, { label: 'Customers' }, { label: 'Customer Details' }]
          }
        },
        {
          path: 'add',
          name: 'addCustomer',
          component: AddCustomerView,
          meta: {
            title: `Add Customer | ${APP_NAME}`,
            breadcrumb: [{ label: 'Home' }, { label: 'Customers' }, { label: 'Add Customer' }]
          }
        },
        {
          path: ':id/edit',
          name: 'editCustomer',
          component: EditCustomerView,
          meta: {
            title: `Edit Customer | ${APP_NAME}`,
            breadcrumb: [{ label: 'Home' }, { label: 'Customers' }, { label: 'Edit Customer' }]
          }
        }
      ]
    },
    {
      path: '/suppliers',
      name: 'suppliers',
      component: Suppliers,
      children: [
        {
          path: '',
          name: 'supplierList',
          component: SupplierListView,
          meta: {
            title: `Suppliers | ${APP_NAME}`,
            breadcrumb: [{ label: 'Home' }, { label: 'Suppliers' }]
          }
        },
        {
          path: ':id',
          name: 'supplierDetails',
          component: SupplierDetailsView,
          meta: {
            title: `Supplier Details | ${APP_NAME}`,
            breadcrumb: [{ label: 'Home' }, { label: 'Suppliers' }, { label: 'Suppliers Details' }]
          }
        },
        {
          path: 'add',
          name: 'addSupplier',
          component: AddSupplierView,
          meta: {
            title: `Add supplier | ${APP_NAME}`,
            breadcrumb: [{ label: 'Home' }, { label: 'suppliers' }, { label: 'Add supplier' }]
          }
        },
        {
          path: ':id/edit',
          name: 'editSupplier',
          component: EditSupplierView,
          meta: {
            title: `Edit Supplier | ${APP_NAME}`,
            breadcrumb: [{ label: 'Home' }, { label: 'Suppliers' }, { label: 'Edit supplier' }]
          }
        }
      ]
    },
    {
      path: '/yarns',
      name: 'yarns',
      component: Yarns,
      children: [
        {
          path: '',
          name: 'yarnList',
          component: YarnListView,
          meta: {
            title: `Yarns | ${APP_NAME}`,
            breadcrumb: [{ label: 'Home' }, { label: 'yarn' }]
          }
        },
        {
          path: 'archieved',
          name: 'archievedYarn',
          component: ArchievedListView,
          meta: {
            title: `Archived Yarns | ${APP_NAME}`,
            breadcrumb: [{ label: 'Home' }, { label: 'Yarns' }, { label: 'Archived Yarn' }]
          }
        },
        {
          path: 'add',
          name: 'addMerge',
          component: AddMergeView,
          meta: {
            title: `Add merge | ${APP_NAME}`,
            breadcrumb: [{ label: 'Home' }, { label: 'Yarns' }, { label: 'Add merge' }]
          }
        },
        {
          path: ':id',
          name: 'yarnDetails',
          component: YarnDetailsView,
          meta: {
            title: `Yarn Details | ${APP_NAME}`,
            breadcrumb: [{ label: 'Home' }, { label: 'Yarns' }, { label: 'Yarn Details' }]
          }
        },
        {
          path: ':id/edit',
          name: 'editYarn',
          component: EditYarnView,
          meta: {
            title: `Edit Yarn | ${APP_NAME}`,
            breadcrumb: [{ label: 'Home' }, { label: 'Yarns' }, { label: 'Edit Yarn' }]
          }
        }
      ]
    },
    {
      path: '/productSpecification',
      name: 'productSpecification',
      component: ProductSpecification,
      children: [
        {
          path: '',
          name: 'productSpecificationListView',
          component: ProductSpecificationListView,
          meta: {
            title: `Product Specification | ${APP_NAME}`,
            breadcrumb: [{ label: 'Home' }, { label: 'Product Specifications' }]
          }
        },
        {
          path: ':id',
          name: 'productSpecificationDetails',
          component: ProductSpecificationDetailsView,
          meta: {
            title: `Product Specification | ${APP_NAME}`,
            breadcrumb: [
              { label: 'Home' },
              { label: 'Product Specifications' },
              { label: 'Product Specification Details' }
            ]
          }
        },
        {
          path: ':id/edit',
          name: 'editProductSpecification',
          component: EditProductSpecificationView,
          meta: {
            title: `Edit Product Specification | ${APP_NAME}`,
            breadcrumb: [
              { label: 'Home' },
              { label: 'Product Specifications' },
              { label: 'Edit Product Specification' }
            ]
          }
        },
        {
          path: 'add',
          name: 'addProduct',
          component: AddProductView,
          meta: {
            title: `Add Product | ${APP_NAME}`,
            breadcrumb: [
              { label: 'Home' },
              { label: 'Product Specifications' },
              { label: 'Add Product' }
            ]
          }
        },
        {
          path: 'archived',
          name: 'archivedProductSpecifications',
          component: ArchivedProductSpecificationListView,
          meta: {
            title: `Archived Product Specifications | ${APP_NAME}`,
            breadcrumb: [
              { label: 'Home' },
              { label: 'Product Specifications' },
              { label: 'Archived Product Specifications' }
            ]
          }
        }
      ]
    },
    {
      path: '/batches',
      name: 'batches',
      component: ProductSpecification,
      children: [
        {
          path: '',
          name: 'batchesListView',
          component: BatchesListView
        },
        {
          path: 'add',
          name: 'addBatch',
          component: AddBatchView
        },
        {
          path: ':id',
          name: 'viewBatch',
          component: BatchDetailsView
        },
        {
          path: 'returned-batch-details/:id',
          name: 'returnedBatchDetails',
          component: ReturnedBatchDetailsview
        },
        {
          path: ':id/returned-from-supplier',
          name: 'returnedFromSupplier',
          component: ReturnedFromSupplier
        },
        {
          path: 'available-batches-details/:id',
          name: 'availableBatchesDetails',
          component: AvailableBatchesDetails
        },
        {
          path: 'dispatched-batches-details/:id',
          name: 'dispatchedBatchesDetails',
          component: DispatchedBatchesDetails
        }
      ]
    },
    {
      path: '/rolls',
      name: 'rolls',
      component: Rolls,
      children: [
        {
          path: '',
          name: 'rollsListView',
          component: RollsListView
        },
        {
          path: ':id',
          name: 'viewRolls',
          component: RollsDetailsView
        },
        {
          path: ':id/edit',
          name: 'editRolls',
          component: EditRollView
        },
        {
          path: 'send-to-supplier',
          name: 'sendToSupplier',
          component: SendToSupplier
        }
      ]
    },
    {
      path: '/orders',
      name: 'orders',
      component: Orders,
      children: [
        {
          path: '',
          name: 'ordersListView',
          component: OrderListView
        },
        {
          path: 'add',
          name: 'addOrder',
          component: AddOrderView
        },
        {
          path: ':id',
          name: 'viewOrder',
          component: OrderDetailsView
        },
        {
          path: ':id/edit',
          name: 'editOrder',
          component: EditOrderView
        },
        {
          path: ':id/addPackingList',
          name: 'createPackingList',
          component: CreatePackingListView
        },
        {
          path: 'cancelled',
          name: 'cancelledOrders',
          component: CancelledOrdersView,
          meta: {
            title: `Cancelled Orders | ${APP_NAME}`,
            breadcrumb: [{ label: 'Home' }, { label: 'Orders' }, { label: 'Cancelled Orders' }]
          }
        }
      ]
    },
    {
      path: '/packingList',
      name: 'packingList',
      component: PackingList,
      children: [
        {
          path: '',
          name: 'packingListView',
          component: PackingListView
        },
        {
          path: ':id',
          name: 'viewPackingList',
          component: PackingListDetailsView
        },
        {
          path: ':id/edit',
          name: 'editPackingList',
          component: EditPackingListView
        }
      ]
    },
    {
      path: '/productionByMachine',
      name: 'productionByMachine',
      component: ProductionByMachineView,
      meta: {
        title: `Production By Machine | ${APP_NAME}`,
        breadcrumb: [{ label: 'Reports' }, { label: 'Production By Machine' }]
      }
    },
    {
      path: '/productionByQuality',
      name: 'productionByQuality',
      component: ProductionByQualityView,
      meta: {
        title: `Production By Quality | ${APP_NAME}`,
        breadcrumb: [{ label: 'Reports' }, { label: 'Production By Quality' }]
      }
    },
    {
      path: '/productionBySupplier',
      name: 'productionBySupplier',
      component: ProductionBySupplierView,
      meta: {
        title: `Production By Supplier | ${APP_NAME}`,
        breadcrumb: [{ label: 'Reports' }, { label: 'Production By Supplier' }]
      }
    },
    {
      path: '/salesByCustomer',
      name: 'salesByCustomer',
      component: SalesByCustomerView,
      meta: {
        title: `Sales By Customer | ${APP_NAME}`,
        breadcrumb: [{ label: 'Reports' }, { label: 'Sales By Customer' }]
      }
    },
      {
      path: '/salesByQuality',
      name: 'salesByQuality',
      component: SalesByQualityView,
      meta: {
        title: `Sales By Quality | ${APP_NAME}`,
        breadcrumb: [{ label: 'Reports' }, { label: 'Sales By Quality' }]
      }
    },
    {
      path: '/costToSaleAnalysis',
      name: 'costToSaleAnalysis',
      component: CostToSaleAnalysisView,
      meta: {
        title: `Cost to Sale Analysis | ${APP_NAME}`,
        breadcrumb: [{ label: 'Reports' }, { label: 'Cost to Sale Analysis' }]
      }
    },
    {
      path: '/yarnStockValue',
      name: 'yarnStockValue',
      component: YarnStockValueView,
      meta: {
        title: `Yarn Stock Value | ${APP_NAME}`,
        breadcrumb: [{ label: 'Reports' }, { label: 'Yarn Stock Value' }]
      }
    },
    {
      path: '/batchStock',
      name: 'batchStock',
      component: BatchStockView,
      meta: {
        title: `Batch Stock | ${APP_NAME}`,
        breadcrumb: [{ label: 'Reports' }, { label: 'Batch Stock' }]
      }
    }
  ]
})


router.beforeEach(async (to, from, next) => {
  const publicPages = ['/login', '/activate-account', '/forgot-password', '/reset-password']
  const authStore = useAuthStore()

  document.title = (to.meta.title as string) || `${APP_NAME}`

  const isPublic = to.meta.public || publicPages.includes(to.path)

  if (isPublic) {
    return next()
  }

  try {
    const isAuthenticated = await ensureValidAccessToken()

    if (to.path === '/') {
      return next(isAuthenticated ? '/dashboard' : '/login')
    }

    if (!isAuthenticated) {
      return next('/login')
    }

    if (isAuthenticated && to.path === '/login') {
      return next('/dashboard')
    }

    next()
  } catch (error) {
    console.error('Router guard error:', error)
    authStore.logout()
    return next('/login')
  }
})

export default router
